module.exports = __webpack_public_path__ + "img/relic.7d0a6a19.png";